import { render, staticRenderFns } from "./InsightsImageSection.vue?vue&type=template&id=09b61d13"
import script from "./InsightsImageSection.vue?vue&type=script&lang=js"
export * from "./InsightsImageSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports